/* @flow */
import React, { useState, useRef } from 'react';
import { IconButton, Popover, Paper, Typography } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import styles from './HelpButton.module.scss';

type Props = {
    type: string,
    helpText: string,
    style?: Object,
    popoverWidth?: number | string,
};

const HelpButton = ({ type, helpText, style, popoverWidth }: Props) => {
    const [open, setOpen] = useState(false);
    const anchorEl = useRef(null);

    return (
        <React.Fragment>
            <IconButton
                ref={anchorEl}
                data-type={type}
                className={styles.iconBtn}
                style={style}
                disableRipple
                onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)}
                data-qa={`${type}_helpBtn`}
                size="large"
            >
                <HelpOutlineIcon fontSize="inherit" />
            </IconButton>
            <Popover
                style={{ pointerEvents: 'none' }}
                open={open}
                anchorEl={anchorEl.current}
                anchorReference="anchorEl"
                onClose={() => setOpen(false)}
                disableRestoreFocus
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
                data-qa={`${type}_helpPopover`}
            >
                <Paper elevation={1}>
                    <Typography
                        component="p"
                        className={styles.helpPopover}
                        style={popoverWidth ? { maxWidth: popoverWidth } : undefined}
                    >
                        <span>{helpText}</span>
                    </Typography>
                </Paper>
            </Popover>
        </React.Fragment>
    );
};

export default HelpButton;
